<template>
  <v-row>
    <!-- not api -->
    <v-col v-if="!api">
    <template v-for="(item, i) in returnItems">
        <div :key="i" class="menu-expandable mb-5">
          <div class="px-0 tcdc-panel-header cursor-pointer" @click="() => onClick(item)">
            <span class="text-uppercase tcdc-menu-title menu-highlight bold">
              {{
              item.name ? $t(item.name) : item[`title_${lang}`]
              }}
            </span>
          </div>
          <div>
            <template v-for="(item, index) of item.subMenuList ? item.subMenuList : item.branches">
              <div
                :key="index"
                class="text-capitalize tcdc-menu-content"
                style="padding-left: 15px;"
                @click="() => onClickSubMenu(item)"
              > {{ item.name ? $t(item.name) : item[`branch_name_${lang}`] }}</div>
            </template>
          </div>
        </div>
      </template>
    </v-col>
    <!-- from API data -->
    <v-col v-else>
      <template v-for="(item, i) in items">
        <div :key="i" class="menu-expandable mb-5">
          <div class="px-0 tcdc-panel-header cursor-pointer" @click="() => onClick(item)">
            <span class="text-uppercase tcdc-menu-title menu-highlight bold">
              {{
              item[`title_${lang}`]
              }}
            </span>
          </div>
          <div>
            <template v-for="(item, index) of item.branches">
              <div
                      :key="index"
                      class="text-capitalize tcdc-menu-content"
                      style="padding-left: 15px;"
                      @click="() => onClickSubMenu(item)"
              > {{ item[`branch_name_${lang}`] }}</div>
            </template>
          </div>
        </div>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import MenuDivider from "../dividers/MenuDivider";
import {mapState} from "vuex";

export default {
  // props: {
  //   title: {
  //     type: String,
  //     default: ""
  //   },
  //   items: {
  //     type: Array
  //   }
  // },
  // methods: {
  //   onClick(item) {
  //     this.$emit("onClick", item);
  //   },
  //   onClickSubMenu(item) {
  //     this.$emit("onClickSubMenu", item);
  //   }
  // }
  data () {
    return {
      optionalArray: []
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array
    },
    optionalSort: {
      default: () => []
    },
    api: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.returnOptionalSort && this.returnOptionalSort.length > 0) {
      this.optionalArray = this.returnOptionalSort
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    }),
    returnItems: function () {
      // for customer requirement 15/07/2021
      if (
          this.items && this.items.length > 0 &&
          this.optionalArray && this.optionalArray.length > 0
      ) {
        return [
          this.items[0],
          this.items[1],
          this.optionalArray[1],
          this.items[4],
          this.items[2],
          this.items[3],
          this.optionalArray[0]
        ]
      }
      return this.items
    },
    returnOptionalSort: function () {
      return this.optionalSort
    }
  },
  watch: {
    returnOptionalSort: function () {
      this.optionalArray = this.returnOptionalSort
    }
  },
  methods: {
    onClick(item) {
      this.$emit("onClick", item);
    },
    onClickSubMenu(item) {
      this.$emit("onClickSubMenu", item);
    }
  }
};
</script>

<style>
.menu-expandable-bg {
  background-color: black !important;
}
</style>
